import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#DA6B1B",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M5.134 13.866c-.467.266-1.067.066-1.334-.4-.133-.2-.133-.4-.066-.667l.533-3.067L2 7.532c-.4-.4-.4-1-.066-1.4.133-.133.4-.266.6-.266l3.133-.467 1.4-2.867c.267-.466.867-.666 1.333-.466.2.066.334.266.467.466l1.4 2.867 3.133.467c.534.066.934.6.867 1.133 0 .2-.133.4-.333.6l-2.267 2.2.533 3.067c.067.533-.266 1.066-.8 1.133-.2.066-.466 0-.666-.067L8 12.4z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }